import { render, staticRenderFns } from "./FamousTitleBar.vue?vue&type=template&id=19437da7&"
import script from "./FamousTitleBar.vue?vue&type=script&lang=js&"
export * from "./FamousTitleBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports